import React from 'react';
import "./loading.css";

const Loading = () => {
    return (
        <div className="background-loding">
            <div className="loading">
                <div className="spinner spinner--steps2 icon-spinner-7" aria-hidden="true"></div>
                <p>계산 중</p>
            </div>
        </div>
    )
};

export default Loading;
